import { useCallback, useEffect, useRef } from 'react'
import styled from 'styled-components';
import {useNavigate} from 'react-router-dom'
import RouteContainer from "../../../common/styles/RouteContainer"
import RowSpacer from "../../../common/styles/RowSpacer"
import SearchBarWithHistoryAndSuggestion from "../../search/searchBar/SearchBarWithHistoryAndSuggestion"
import breakpoints from '../../../config/Breakpoints';
import booksitoutIcon from '../../../config/BooksitoutIcon';
import RouteTitle from '../../../common/RouteTitle/RouteTitle';
import RouteTitleConfig from '../../../config/RouteTitleConfig';
import LibraryByBookCountCard from './LibraryByBookCountCard';
import LibraryDataAttribution from './LibraryDataAttribution';
import useHtmlTitle from "../../../common/useHtmlTitle";
import IndexLibraryCard from "../../index/card/IndexLibraryCard";
import {Helmet} from 'react-helmet-async'
import { SearchBarHandle } from '../../search/searchBar/SearchBar'

const mapLibrarySearchHistory = (data: any[]) => {
    return data.map((item, index) => ({
        id: item.libraryId ?? index,
        query: item.name,
        date: new Date(),
        url: item.type === 'LIBRARY'
            ? `/library/${item.libraryId}`
            : `/library/by-region/${item.regionEnglishName?.toLowerCase()}/${item.regionDetailEnglishName?.toLowerCase()}`,
        imageUrl: item.imageUrl,
        isbn: null,
        secondaryQuery: item.type !== 'LIBRARY' ? '지역' : null,
    }))
}

const LibraryRoute = () => {
    const navigate = useNavigate()
    useHtmlTitle('도서관')
    const searchBarRef = useRef<SearchBarHandle>(null)

    const handleKeyDown = useCallback((e: KeyboardEvent) => {
        if ((e.ctrlKey || e.metaKey) && e.key === 'f') {
            e.preventDefault()
            searchBarRef.current?.focus()
        }
    }, [])

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [handleKeyDown])

    return (
        <RouteContainer>
            <Helmet>
                <meta property='og:title' content='책잇아웃: 도서관'/>
                <meta property='og:description' content='내 주변 도서관을 쉽게 발견하고 도서관 회원증 관리까지'/>
            </Helmet>

            <RouteTitle
                icon={<booksitoutIcon.library/>}
                title={'도서관 찾기'}
                subTitle={'여러 조건으로 도서관을 찾을 수 있어요'}
                currentKey={'library'}
                buttons={RouteTitleConfig.Library}
            />

            <RowSpacer/>
            <SearchBarContainerContainer>
                <SearchBarContainer>
                    <SearchBarWithHistoryAndSuggestion
                        ref={searchBarRef}
                        autoCompleteApiUrl={`/v1/library/search/auto-complete`}
                        searchHistoryApiUrl={`/v1/library/search/histories`}
                        searchHistoryCacheKey={null}
                        searchResultUrl={'/library/search'}
                        placeholder={'이름, 지역으로 도서관 찾기'}
                        isHandleSubmit={false}
                        isShouldUpdateQueryParam={false}
                        autoCompleteTimeout={50}
                        mapSearchHistoryResponse={mapLibrarySearchHistory}
                        handleQuerySuggestionClick={(suggestion) => {
                            if (suggestion.url) {
                                navigate(suggestion.url)
                            }
                        }}
                    />
                </SearchBarContainer>
            </SearchBarContainerContainer>
            <RowSpacer size={60}/>

            <IndexLibraryCard isIndex={true}/>
            <RowSpacer size={40}/>

            <LibraryByBookCountCard/>
            <RowSpacer size={40}/>

            <LibraryDataAttribution/>
        </RouteContainer>
    )
}

const SearchBarContainerContainer = styled.div`
    display: flex;
    justify-content: center;
`;

const SearchBarContainer = styled.div`
    width: 50%;

    @media screen and (max-width: ${breakpoints.md}) {
        width: 100%;
    }
`;

export default LibraryRoute
